import { render, staticRenderFns } from "./EditComment.vue?vue&type=template&id=366a2f54&"
import script from "./EditComment.vue?vue&type=script&lang=js&"
export * from "./EditComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports